module.exports = __webpack_public_path__ + "img/opp-errf-point-excl.ce3cf353.png";